import { AccessTime, CarRental } from "@mui/icons-material";
import { Link, Stack, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import dayjs from "dayjs";
import { useWatch } from "react-hook-form";

import { IFormValues } from "../../../../types";
import {ILocation, RentalLocationType} from "../../../../../../types";



const LocationHelperText = ({
                                location,
                                locationType
                            }: {
    location: ILocation | null,
    locationType: RentalLocationType
}) => {

    const { t } = useTranslation('booking');

    const pickupDate = useWatch<IFormValues, 'basicDetails.pickupDate'>({
        name: 'basicDetails.pickupDate'
    });

    if (!location) {
        return null;
    }

    return (
        <Stack direction="row" justifyContent="space-between" alignItems="start">
            <Link
                component={RouterLink}
                to={`/mobility-store/dms-detail/${location.ntwId}`}
                target="_blank"
            >
                {t('label.dmsInfo')}
            </Link>
            <Stack direction="row" alignItems="center" columnGap={.5}>
                {((location?.afterHours && locationType === RentalLocationType.Pickup) ||
                    (locationType === RentalLocationType.Pickup && !!pickupDate && pickupDate.format("YYYY-MM-DD") === dayjs().format("YYYY-MM-DD") )) &&
                <Tooltip
                    title={t('label.afterHours')}
                >
                    <AccessTime
                        fontSize="medium"
                        color="secondary"
                    />
                </Tooltip>
                }
                {locationType === RentalLocationType.Dropoff && location?.keybox &&
                <Tooltip
                    title={t('label.keyBox')}
                >
                    <CarRental
                        fontSize="medium"
                        color="secondary"
                    />
                </Tooltip>
                }
            </Stack>
        </Stack>

    );
};

export default LocationHelperText;
